import { render, staticRenderFns } from "./JobsTableServerPaged.vue?vue&type=template&id=08101d67"
import script from "./JobsTableServerPaged.vue?vue&type=script&lang=ts"
export * from "./JobsTableServerPaged.vue?vue&type=script&lang=ts"
import style0 from "./JobsTableServerPaged.vue?vue&type=style&index=0&id=08101d67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports